import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "../navigation/Header";

const HeaderLayout = () => {
  return (
    <Box>
      <Header />
      <Box component="main" sx={{ p: 2, pt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default HeaderLayout;
